import { useLocalStore } from "@/context/StateContext";
import { DataTypes } from "@/context/StateContext";
import Types from "@/types";
import { createEffect, createSignal } from "solid-js";

export default function Name(props: { id: string }) {
  const localStore = useLocalStore()
  const [name, setName] = createSignal<string>(props.id)

  createEffect(async () => {
    // Check Types enum
    if (Object.values(Types).includes(props.id as Types)) {
      const typeName = Object.keys(Types).find(key => Types[key as keyof typeof Types] === props.id)
      setName(typeName || props.id)
      return
    }
    // Check DataTypes enum
    if (Object.values(DataTypes).includes(props.id as DataTypes)) {
      const typeName = Object.keys(DataTypes).find(key => DataTypes[key as keyof typeof DataTypes] === props.id)
      setName(typeName || props.id)
      return
    }

    if (!localStore.database) return
    const query = await localStore.database.find({
      selector: {
        origin: props.id,
        type: Types.Name
      }
    })
    setName(query.docs?.[0]?.target || props.id)
  })

  return (
    <>{name()}</>
  )
}
